import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Globals } from '../../../_globals/globals';

import { Location } from '@angular/common';

@Component({
  selector: 'app-document-show',
  templateUrl: './document-show.component.html'
})

export class DocumentShowComponent implements OnInit, AfterViewInit {

  title: string;
  subtitle: string;

  permissions: string;
  permissionList: any;

  pdf_file = ''; // './assets/attachments/documents/impresion.pdf';

  sub: any;
  // paramNum: number;
  paramRefresh: string;
  paramFile: string;
  paramBack: string;

  setTimeout_aux: number;
  pdfBaseUrl: string;

  @ViewChild('searchButton',  {static: true}) searchButton: ElementRef;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private globals: Globals,
    private _location: Location
  ) {}

  // IMPORTANTE: Para que funcione en local esta sección y muestre bien los pdf se necesita que esté compilado
  // con la instrucción "ng build --prod" con el path de guardado local, no basta con sólo modificar en el archivo.
  ngOnInit() {
    this.title = 'Visor de Documentos';
    this.subtitle = 'Impreso';

    console.log('-> -> Iniciando Document-Show:' + this.title);

    this.setTimeout_aux = 1000;

    this.sub = this.route.params.subscribe(params => {
      // this.paramNum = +params['num']; // Importante el '+' para obtener números
      this.paramFile = params['ff'];
      this.paramRefresh = params['rf'];
      this.paramBack = params['rb'];
    });

    console.log('Parámetro refresco = ');
    console.log(this.paramRefresh);
    console.log('Parámetro archivo = ');
    console.log(this.paramFile);
    console.log('Parámetro back = ');
    console.log(this.paramBack);

    // Se vuelve a recargar la página (sin pasar parámetro) para que se actualice el archivo común "impreso.pdf".
    if (this.paramRefresh === 'true' && this.paramFile !== '' && this.paramFile !== undefined && this.paramFile !== null) {

      setTimeout(() => {this.router.navigate(['/document', this.paramFile, false, this.paramBack])}, this.setTimeout_aux);

    }

    if (this.paramRefresh === 'false' && this.paramFile !== '' && this.paramFile !== undefined && this.paramFile !== null) {
      this.pdfBaseUrl = this.resolveBackendBaseUrl();
      this.pdf_file = this.pdfBaseUrl + '/assets/attachments/documents/' + this.paramFile + '?v=' + Date.now();
      console.log('Document-Show pdf_file:');
      console.log(this.pdf_file);
      this.searchButton.nativeElement.data = this.pdf_file;
    }

    this.permissions = localStorage.getItem('permissions');
    console.log('-> -> Iniciando Document-Show permissions:' + this.permissions);

    // No se va a usar en esta sección.
    this.permissionList = this.globals.permissionList; // ['Administrador', 'Supervisor', 'Comercial'];

    // this.showDocument();

  } // End function ngOnInit


  // Esta función se ejecuta después de ngOnInit.
  ngAfterViewInit() {

    // console.log('-> -> ngAfterViewInit Document-Show 1:');
    // console.log(this.searchButton.nativeElement.data);

    // this.searchButton.nativeElement.data = this.pdf_file;

    // console.log('-> -> ngAfterViewInit Document-Show 2:');
    // console.log(this.searchButton.nativeElement.data);

  } // End function ngAfterViewInit

  selectSection(value: string) {
    console.log('-> -> Seleccionada sección:' + value);

    this.router.navigate(['/' + value]);
  }

  showDocument(): void {
    const baseUrl = this.resolveBackendBaseUrl();
    window.open(baseUrl + '/assets/attachments/documents/impresion.pdf?v=' + Date.now());
  } // End function show

  private resolveBackendBaseUrl(): string {
    const apiUrl = this.globals && this.globals.apiUrl ? String(this.globals.apiUrl) : '';
    if (apiUrl !== '') {
      return apiUrl.replace(/\/api\/?$/, '');
    }

    const host = window && window.location ? window.location.hostname : '';
    const isLocal = host === 'localhost' || host === '127.0.0.1';
    if (isLocal && this.globals && this.globals.apiUrlList && this.globals.apiUrlList['local']) {
      return String(this.globals.apiUrlList['local']).replace(/\/api\/?$/, '');
    }

    return '';
  }

  back(): void {
    // this._location.back();
    // this.router.navigate(['/budget-resume']);

    // Se coloca la ruta de vuelta cogiendo el valor indicado en el parámetro paramBack.
    if (this.paramBack && this.paramBack !== '') {
      this.router.navigate(['/' + this.paramBack]);
    } else {
      this.router.navigate(['/file-list']);
    }
  } // End function back

  // Función que cierra la pestaña de navegación.
  close(): void {
    // Si la ventana no fue abierta por script, el navegador bloqueará window.close().
    // En ese caso volvemos a la sección anterior.
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }

    this.back();
  } // End function close

} // End DocumentShowComponent
